export default {
  namespaced: true,
  state: {
    crossLanePromoSlidePage: 1, // starts from 1
    showCrossLanePromotionComponent: true,
  },
  mutations: {
    setCrossLanePromoSlidePage(state, value) {
      state.crossLanePromoSlidePage = value;
    },
    setShowCrossLanePromotionComponent(state, value) {
      state.showCrossLanePromotionComponent = value;
    },
  },
  actions: {
    updateCrossLanePromoSlidePage({ commit }, value) {
      commit('setCrossLanePromoSlidePage', value);
    },
    updateShowCrossLanePromotionComponent({ commit }, value) {
      commit('setShowCrossLanePromotionComponent', value);
    },
  },
  getters: {
    crossLanePromoSlidePage: (state) => state.crossLanePromoSlidePage,
    showCrossLanePromotionComponent: (state) => state.showCrossLanePromotionComponent,
  },
};
